import { Button, Stack, Typography } from '@mui/material'
import AssignEngineerModalComponent from './AssignEngineerModalComponent'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { showAssignEngineerDialog } from '../../actions/organization'
import { AssignDiscipline } from '../../models/Review'

interface AssignEngineerProps {
  discipline: AssignDiscipline
}

const AssignEngineerComponent: React.FC<AssignEngineerProps> = ({
  discipline,
}) => {
  const dispatch = useDispatch<any>()
  const organization = useSelector((state: RootState) => state.organization)

  return (
    <Stack
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1rem'}
      width={'100%'}
      minHeight={'5.8rem'}
    >
      <Typography
        sx={{
          color: '#797979',
          fontSize: '0.7rem',
          fontWeight: 500,
          lineHeight: 'тormal',
        }}
      >
        Assign an engineer from your team
      </Typography>
      <Button
        variant='contained'
        onClick={() => dispatch(showAssignEngineerDialog(true))}
        sx={{
          fontSize: '0.64rem',
          background: '#FF3B47',
          textTransform: 'capitalize',
          minWidth: '5rem',
          height: '1.5rem',
        }}
      >
        Assign
      </Button>
      <AssignEngineerModalComponent
        isOpen={organization.showAssignEngineerModal}
        discipline={discipline}
        handleClose={() => dispatch(showAssignEngineerDialog(false))}
      />
    </Stack>
  )
}

export default AssignEngineerComponent
